export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5821.79ace2b4.jpg";